import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-product',
  templateUrl: './catalogs-product.component.html',
  styleUrls: ['./catalogs-product.component.scss']
})
export class CatalogsProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
